// extracted by mini-css-extract-plugin
module.exports = {"physicalPlantConfig":"styles_physicalPlantConfig__h4YiT","PPCData":"styles_PPCData__2zZxF","splitterBackground":"styles_splitterBackground__3PrOE","button":"styles_button__QUnDu"};